import { Suspense } from 'react'
import { Outlet } from 'react-router'

import { SectionLoader } from '@/components/common/FullPageLoader'
import { env } from '@/config/env'

/** Centered chrome for unauthenticated screens. */
export function AuthLayout() {
  return (
    <div className="bg-muted/40 flex min-h-dvh flex-col items-center justify-center gap-6 p-6">
      <div className="flex items-center gap-2">
        <img src="/logo-mark.svg" alt="" className="h-9 w-auto" aria-hidden />
        <span className="text-xl font-semibold">{env.appName}</span>
      </div>
      <Suspense fallback={<SectionLoader />}>
        <Outlet />
      </Suspense>
    </div>
  )
}
